<template lang="pug">
div.stats
  SectionTitle(:sectionText="title")
  StatisticsData(v-for='(item, idx) in items' :key='idx' :icon='item.icon' :title='item.text' :subText='subText' :info='infos[idx]')
</template>

<script>
import StatisticsData from '@/components/statistics/statistics_data.vue';
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import { setGtag } from '@/plugins/gtag.js';

export default {
  props: {
    title: String,
    items: Array,
    type: String,
    subText: String
  },
  components: {
    StatisticsData,
    SectionTitle
  },
  data() {
    return {
      infos: [],
      typeDict: {}
    };
  },
  created() {
    this.typeDict.today = this.$store.state.routes.todayStats;
  },
  async mounted() {
    await this.getInfo();
    for (let i = 0; i < this.infos.length; ++i) {
      setGtag(
        this.items[i].text,
        'statistics',
        this.items[i].text,
        this.infos[i]
      );
    }
  },
  methods: {
    async getInfo() {
      let route =
        this.$store.state.URLs.api +
        '/' +
        this.$store.state.lang +
        this.typeDict[this.type];

      let result = await this.$axios.get(route);

      let l = Object.values(result.data);
      l.forEach(v => {
        this.infos.push(v);
      });
    }
  }
};
</script>
